import {
  AddTestKitPayload,
  AssignTestKitToDoctorPayload,
  AssignTestKitToPatientPayload,
  UpdateKitStatusPayload,
  UpdateTestKitNotesPayload,
  UploadCsvReportPayload,
  UploadPdfReportPayload,
} from "@/common/types";
import axiosInstance from "./axiosInstance";
import { STATUS_ASSIGNED, STATUS_UNASSIGNED } from "@/common/constant";
import { isUserAdmin, isUserDoctor } from "@/utils/common.util";

export const getTestsKitListApi = (
  page: number = 1,
  doctor: string = "",
  patient: string = "",
  status: string = "",
  pageSize?: number
) => {
  let url = `/test-kits/?page=${page}`;
  if (patient !== "") {
    url = url + `&assigned_patient=${patient}`;
  }
  if (doctor !== "") {
    url = url + `&assigned_doctor=${doctor}`;
  }
  if (status === STATUS_ASSIGNED) {
    if (isUserAdmin()) {
      url = url + "&is_doctor_assigned=true";
    } else if (isUserDoctor()) {
      url = url + "&is_patient_assigned=true";
    }
  } else if (status === STATUS_UNASSIGNED) {
    if (isUserAdmin()) {
      url = url + "&is_doctor_assigned=false";
    } else if (isUserDoctor()) {
      url = url + "&is_patient_assigned=false";
    }
  }
  if (pageSize) {
    url = url + `&page_size=${pageSize}`;
  }
  const response = axiosInstance.get(url);
  return response;
};

export const addTestKitApi = (payload: AddTestKitPayload) => {
  const response = axiosInstance.post("/test-kits/", payload);
  return response;
};

export const getTestKitDetailApi = (id: number) => {
  const response = axiosInstance.get(`/test-kits/${id}/`);
  return response;
};

export const assignTestKitToDoctorApi = (
  payload: AssignTestKitToDoctorPayload
) => {
  const response = axiosInstance.post(`/test-kits/assign-doctor`, payload);
  return response;
};

export const assignTestKitToPatientApi = (
  id: number,
  payload: AssignTestKitToPatientPayload
) => {
  const response = axiosInstance.post(
    `/test-kits/${id}/assign-patient`,
    payload
  );
  return response;
};

export const updateTestKitNotesApi = (
  id: number,
  payload: UpdateTestKitNotesPayload
) => {
  const response = axiosInstance.post(`/test-kits/${id}/notes`, payload);
  return response;
};

export const shareResultToPatientApi = (id: number) => {
  const response = axiosInstance.post(
    `/test-kits/${id}/share-result-to-patient`
  );
  return response;
};

export const updateKitStatusApi = (
  id: number,
  payload: UpdateKitStatusPayload
) => {
  const response = axiosInstance.post(
    `/test-kits/${id}/update-status`,
    payload
  );
  return response;
};

export const uploadCsvReportApi = (
  id: number,
  payload: UploadCsvReportPayload
) => {
  const formData = new FormData();
  formData.append("taxa_file", payload.taxa_file as Blob);
  formData.append("metrics_file", payload.metrics_file as Blob);
  const response = axiosInstance.post(`/test-kits/${id}/reports`, formData);
  return response;
};

export const uploadPdfReportApi = (
  id: number,
  payload: UploadPdfReportPayload
) => {
  const formData = new FormData();
  formData.append("result_file", payload.result_file as Blob);
  const response = axiosInstance.post(`/test-kits/${id}/results`, formData);
  return response;
};

export const downloadAnalysisApi = (id: number) => {
  const response = axiosInstance.get(`/test-kits/${id}/download-analysis`);
  return response;
};

export const downloadResultApi = (id: number) => {
  const response = axiosInstance.get(`/test-kits/${id}/download-result`);
  return response;
};

export const getVisualizationDataApi = (id: number) => {
  const response = axiosInstance.get(`/test-kits/${id}/visualization`);
  return response;
};

export const giveConsentApi = (id: number) => {
  const response = axiosInstance.post(`/test-kits/${id}/give-test-consent`);
  return response;
};

export const revokeResultFromPatientApi = (id: number) => {
  const response = axiosInstance.post(`/test-kits/${id}/undo-share-results`);
  return response;
};
